/**
* @author 贝才[beica1@outook.com]
* @date 2021/3/11
* @description
*   ThePositionEditDialog.vue of WeTrade
*/
<template>
<DialogTemplate @cancel="$emit('close')">
  <template #title>
    <t path="symbol_34">Modify</t>
  </template>
  <div class="flex-1">
    <div class="d-f my-16">
      <div class="flex-1 f-bold">Entry Price</div>
      {{position.createPrice}}
    </div>
    <TheStopLoss show-distance />
    <TheTakeProfit show-distance />
  </div>
  <template #confirm>
    <Button class="flex-1 primary" @click="saveEdit" :progress="progress">
      <t path="symbol_38" #="{td}" custom>{{td || 'Submit'}}</t>
    </Button>
  </template>
</DialogTemplate>
</template>

<script lang="ts">
import Button from '@/components/Button.vue'
import { openDialog } from '@/components/popup/popup'
import { events } from '@/config'
import ThePositionEditResultDialog from '@/modules/trade/components/ThePositionEditResultDialog.vue'
import TheStopLoss from '@/modules/trade/components/TheStopLoss.vue'
import TheTakeProfit from '@/modules/trade/components/TheTakeProfit.vue'
import Order from '@/modules/trade/Order'
import { useEdit } from '@/modules/trade/trade'
import { Position, readProduct } from '@/modules/trade/trade.api'
import DialogTemplate from '@/views/DialogTemplate.vue'
import { emit } from 'essential/tools/event'
import { defineComponent, provide } from 'vue'

export default defineComponent({
  name: 'ThePositionEditDialog',
  components: {
    TheTakeProfit,
    TheStopLoss,
    Button,
    DialogTemplate,
  },
  emits: ['close'],
  props: {
    position: {
      type: Object,
      required: true,
    },
  },
  setup (props, ctx) {
    const position = props.position as Position

    const model = new Order(position.type, {
      orderId: position.orderId,
      price: position.createPrice,
      isJuan: position.isJuan,
      stopProfit: position.stopProfitPoint,
      stopLoss: position.stopLossPoint,
      isTrackSt: position.isTrackSt,
      createPrice: position.createPrice,
    })

    provide('order', model)

    readProduct({ productId: position.productId })
      .then(resp => model.updateProduct(resp))

    const [commit, progress] = useEdit()

    return {
      progress,
      product: model.getProduct(),
      saveEdit () {
        commit(model.getValue()).then(() => {
          emit(events.transactionUpdate)
          openDialog(ThePositionEditResultDialog, {
            top: model.takeProfit.value,
            bottom: model.stopLoss.value,
          })
          ctx.emit('close')
        })
      },
    }
  },
})
</script>
